import { CommonState } from "./states/common.state.interface";

export default {
  namespaced: true,
  state: {
    status: ["ACTIVE", "INACTIVE"],
    roles: ["ADMINISTRATOR", "EDITOR"]
  },
  getters: {
    getStatus: (state: CommonState) => state.status,
    getRoles: (state: CommonState) => state.roles
  },
  mutations: {},
  actions: {}
};
